import { render, staticRenderFns } from "./ClaimsView.vue?vue&type=template&id=08aab853&"
import script from "./ClaimsView.vue?vue&type=script&lang=js&"
export * from "./ClaimsView.vue?vue&type=script&lang=js&"
import style0 from "./ClaimsView.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports